import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HeartIcon } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function CategorySubscribeButton({ category, size = "sm" }) {
  const { user } = useAuth() || {};
  const [subbed, setSubbed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!user) {
      setLoaded(true);
      return;
    }
    (async () => {
      try {
        const r = await api.get("/me/category-subs");
        setSubbed((r.data.categories || []).includes(category));
      } catch {
        /* network — leave default */
      }
      setLoaded(true);
    })();
  }, [user, category]);

  const onToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      window.location.href = "/login?next=/categories";
      return;
    }
    setBusy(true);
    try {
      if (subbed) {
        await api.delete(`/me/category-subs/${encodeURIComponent(category)}`);
        setSubbed(false);
        toast.success(`Unfollowed ${category}`);
      } else {
        await api.post("/me/category-subs", { category });
        setSubbed(true);
        toast.success(`Following ${category} — we'll ping you on new drops.`);
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
    setBusy(false);
  };

  if (!loaded) return null;

  const big = size === "lg";
  return (
    <button
      onClick={onToggle}
      disabled={busy}
      data-testid={`cat-sub-${category}`}
      aria-pressed={subbed}
      className={`inline-flex items-center gap-1.5 rounded-full font-bold transition-colors ${
        big ? "px-4 py-2 text-sm" : "px-3 py-1.5 text-xs"
      } ${
        subbed
          ? "bg-zinc-100 text-zinc-600 border border-zinc-300 hover:bg-zinc-200"
          : "bg-[#1D78AB] text-white border border-[#1D78AB] hover:bg-[#165d85]"
      } disabled:opacity-50`}
    >
      <HeartIcon size={big ? 16 : 13} weight={subbed ? "fill" : "regular"} />
      {subbed ? "Following" : "Follow"}
    </button>
  );
}
